var map = {
	"./figurine_astrid.png": 344,
	"./figurine_bea.png": 345,
	"./figurine_caroline.png": 346,
	"./figurine_corinne.png": 347,
	"./figurine_cornelus.png": 348,
	"./figurine_didier.png": 349,
	"./figurine_diego.png": 350,
	"./figurine_gerry.png": 351,
	"./figurine_henry.png": 352,
	"./figurine_herbert.png": 353,
	"./figurine_karla.png": 354,
	"./figurine_kitou.png": 355,
	"./figurine_leon.png": 356,
	"./figurine_martin.png": 357,
	"./figurine_maurice.png": 358,
	"./figurine_max.png": 359,
	"./figurine_milla.png": 360,
	"./figurine_olga.png": 361,
	"./figurine_pol.png": 362,
	"./figurine_renee.png": 363,
	"./figurine_ric.png": 364,
	"./figurine_sam.png": 365,
	"./figurine_viktor.png": 366,
	"./figurine_waldo.png": 367
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/figurines nonrecursive \.png$
// module id = 221
// module chunks = 6 7 8